/**
 * Lazy load for tabs / accordions
 * @dependencies jQuery
 * @dependencies Foundation
 */

import $ from 'jquery';

// Tabs
$('[data-tabs]').on('change.zf.tabs', function () {
  const tabContent = $(this).siblings('[data-tabs-content]').get(0);
  Drupal.drimage.init(tabContent);
});

// Accordions
$('[data-accordion]').on('down.zf.accordion', function () {
  const accordionContent = $(this).get(0);
  Drupal.drimage.init(accordionContent);
})
